export default __webpack_public_path__ + "static/media/menu.6724e5da.svg";